import 'jquery-validation';
import {showButtonLoader, hideButtonLoader} from '../../util/helpers';

export default {
  init: function () {

    var promotionsForm = $('#promotionsForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);
      
      setTimeout(() => {
        var valid = promotionsForm.valid();
        if (valid) {
          setTimeout(function () {
            promotionsForm.submit();
          }, 1000);
        }else {
          hideButtonLoader(submitButton);
        }
      }, 1000);
    });

    promotionsForm.validate({
      errorElement: "span",
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/account/promo.js